$(document).foundation();

$(window).on('load', function () {
    setTimeout(function () {
        $('.wrapper').addClass('loaded');
    }, 300);

    var ele = $('[data-participation]');

    ele.on('init', function () {
        $('#startnow').on('click', function (e) {
            e.preventDefault();

            $.ajax({
                url: 'https://kfc.endofyearwishes.com/',
                method: 'POST',
                data: {
                    create_session: true
                },
                success: function (result) {
                    if(result === 'success') {
                        ele.slick('slickGoTo', 1);
                    }
                }
            });
        });

        $('#username').keyup(function() {
            var maxLength = $(this).attr('maxlength');
            var textlen = maxLength - $(this).val().length;
            $('.charactercount').text(textlen+'/'+maxLength);
        }).keyup();

        $('#username').on('keyup', function () {
            var username = $(this);

            if (username.val() === '') {
                username.addClass('error');
                $('#savename').addClass('disabled');
            } else {
                username.removeClass('error');
                $('#savename').removeClass('disabled');
            }
        });

        $('#savename').on('click', function (e) {
            e.preventDefault();
            var username = $('#username');

            if (username.val() === '') {
                username.addClass('error');
            } else {
                username.removeClass('error');

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                'event': 'nameregistered'
                });

                $.ajax({
                    url: 'https://kfc.endofyearwishes.com/',
                    method: 'POST',
                    data: {
                        type_name: true,
                        name: username.val()
                    },
                    dataType: 'json',
                    success: function (result) {
                        if(result.status === 'session_timeout') {
                            location.reload();
                        } else {
                            $("#user_generated_card").attr('src', result.image);
                            $("#fbShareButton").attr('href', result.link);
                            $("#waShareButton").attr('href', result.walink);
                            ele.slick('slickGoTo', 2);
                        }
                    }
                });
            }
        });

        $('#waShareButton').on('click', function () {
            ele.slick('slickGoTo', 3);
        });

        $('#fbShareButton').on('click', function (e) {
            e.preventDefault();

            FB.ui({
                method: 'share',
                href: $(this).attr('href')
            }, function(response){
                if(response.error_message) {
                    location.reload();
                } else {
                    ele.slick('slickGoTo', 3);
                }
            });
        });
    }).on('afterChange', function (event, slick, currentSlide) {
        if (currentSlide === 3) {
            $('body').addClass('colonel-greetings');
        } else {
            $('body').removeClass('colonel-greetings');
        }
    }).slick({
        adaptiveHeight: true,
        draggable: false,
        infinite: false,
        //initialSlide: 3,
        arrows: false,
        swipe: false,
        fade: true,
        dots: true
    });
})